import { DataBaseModelInterface } from '@solcre-org/core';
import { TimeFieldValue } from '@solcre-org/core-ui';
import { PortOvertimeLevel } from '../../../shared/enums/port-overtime-level.enum';

export class PortOvertimeRuleFormModel implements DataBaseModelInterface {
  constructor(
    public level: PortOvertimeLevel | string = PortOvertimeLevel.OT1,
    public daysOfWeek: number[] = [],
    public time: TimeFieldValue = { startTime: null, endTime: null }
  ) {}

  fromJSON(json: any): PortOvertimeRuleFormModel {
    if (json) {
      this.level = json.level ?? PortOvertimeLevel.OT1;
      this.daysOfWeek = Array.isArray(json.daysOfWeek) ? [...json.daysOfWeek].map(Number) : [];
      this.time = { startTime: json.startTime ?? null, endTime: json.endTime ?? null };
    }
    return this;
  }

  toJSON() {
    return {
      level: this.level,
      daysOfWeek: this.daysOfWeek,
      startTime: this.time?.startTime ?? null,
      endTime: this.time?.endTime ?? null,
    };
  }

  getId() {
    return '';
  }

  getReference() {
    return '';
  }
}
